import React from 'react'
import questions from '../questions_data/questions';
import questions_chi from '../questions_data/questions_chi'
import { Input, FormControl, RadioGroup, FormControlLabel, Radio, Grid, Checkbox, Typography } from '@mui/material';
import Select from 'react-select';
import DateInputField from './DateInputField';
import OtherInput from './OtherInput';

function AnswerTypes(props) {
    let answersArray

    if (props.language === "questions") {
        answersArray = questions[props.currentQuestion].answerOptions
    }
    else if (props.language === "questions_chi") {
        answersArray = questions_chi[props.currentQuestion].answerOptions
    }

    const listOfRadio = answersArray.map((answers) => <FormControlLabel className='radio-button' key={answers} value={answers} control={<Radio />} label={answers} />)

    if (props.type === "radio") {
        return (
            <FormControl>
                <RadioGroup
                    name={props.name}
                    onChange={props.handleChangeAndAnswer}
                    value={props.value ?? " "}
                    defaultValue=""
                    required
                >
                    {listOfRadio}
                </RadioGroup>
            </FormControl>
        )
    }
    if (props.type === "radio-input") {
        const newName = props.name + "_others"
        if (props.value !== "Yes" && props.value !== "是") {
            return (
                <FormControl>
                    <RadioGroup
                        name={props.name}
                        onChange={props.handleChange}
                        value={props.value ?? " "}
                        defaultValue=""
                        required
                    >
                        {listOfRadio}
                    </RadioGroup>
                </FormControl>
            )
        } else {
            return (
                <div>
                    <FormControl>
                        <RadioGroup
                            name={props.name}
                            onChange={props.handleChange}
                            value={props.value ?? " "}
                            defaultValue=""
                            required
                        >
                            {listOfRadio}
                        </RadioGroup>
                    </FormControl>
                    <Grid container mt={7} mb={7} ml="auto" mr="auto" maxWidth="900px" display="flex" justifyContent="center">
                        <Typography>If there are others, please specify:</Typography>
                        <Input
                            name={newName}
                            value={props.otherValue}
                            onChange={props.handleChange}
                            inputProps={{ style: { textAlign: 'center', marginTop: '16px' } }}
                            fullWidth={true}
                            placeholder="Others"
                            autoFocus
                        />
                    </Grid>
                </div>
            )
        }
    }

    if (props.type === "date") {
        return (
        <DateInputField 
            state={props.state}
            setState={props.setState}
            language={props.language}
        />
        )
    }

    if (props.type === "input") {
        return (
            <FormControl>
                <Input
                    name={props.name}
                    value={props.value}
                    onChange={props.handleChange}
                    endAdornment={props.endAdornment}
                    inputProps={props.inputProps}
                    fullWidth={props.fullWidth}
                    autoFocus={props.autoFocus}
                    variant="outlined"
                />
            </FormControl>
        )
    }

    if (props.type === "select") {
        const name = props.name
        return (
            <div>
                <Select
                    name={name}
                    options={props.options}
                    value={props.value}
                    isSearchable={props.isSearchable}
                    closeMenuOnSelect={props.closeMenuOnSelect}
                    isMulti={props.isMulti}
                    is={props.isOptionSelected}
                    onChange={((evt) => {
                        if (props.isMulti === false && evt.label !== "其他" && evt.label !== "Others") {
                            props.goNextQuestion()
                        }
                        props.setState({
                            ...props.state,
                            [name]: evt
                        });
                    })}
                />
                <OtherInput
                    name={name}
                    value={props.value}
                    otherValue={props.otherValue}
                    state={props.state}
                    setState={props.setState}
                />
            </div>
        )
    }

    if (props.type === "terms") {
        return (
            <Grid container
                display="flex"
                flexDirection="column"
                gap={6}
                justifyContent="center"
                maxWidth={{ xs: "90%", sm: "80%" }}
                mb={{ xs: "24px", sm: "0px" }}
                margin="auto">
                <Grid item
                    display="flex"
                    flexDirection="column"
                    gap={3}>
                    <Typography textAlign="left" variant="body1">{answersArray[0].terms}</Typography>
                    <FormControlLabel name="research_consent" key="research_consent" value="I understand and agree to be a research subject." onChange={e => props.setState({ ...props.state, [e.target.name]: e.target.checked })} control={<Checkbox />} label={answersArray[0].agree} sx={{ textAlign: "left" }} />
                </Grid>
                <Grid item
                    display="flex"
                    flexDirection="column"
                    gap={3}>
                    <Typography textAlign="left" variant="body1">{answersArray[1].terms}</Typography>
                    <FormControlLabel name="personal_data" key="personal_data" value="I agree to receive marketing material that includes information on new products and services and updates on latest promotions" onChange={e => props.setState({ ...props.state, [e.target.name]: e.target.checked })} control={<Checkbox />} label={answersArray[1].agree} sx={{ textAlign: "left" }} />
                </Grid>
                <Grid item
                    display="flex"
                    flexDirection="column"
                    gap={3}>
                    <Typography textAlign="left" variant="body1">{answersArray[2].terms}</Typography>
                    <FormControlLabel name="terms_of_service" key="terms_of_service" value="I understand and accept the Terms of Service" onChange={e => props.setState({ ...props.state, [e.target.name]: e.target.checked })} control={<Checkbox />} label={answersArray[2].agree} sx={{ textAlign: "left" }} />
                </Grid>
            </Grid>
        )
    }
}

export default AnswerTypes